export default __webpack_public_path__ + "static/media/WEXpoly.8ed714eb.png";